export async function retryRequest<T>(
  operation: () => Promise<T>,
  attempts = 3,
  delayMs = 300,
  shouldRetry: (error: unknown) => boolean = () => true,
): Promise<T> {
  let lastError: unknown;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      return await operation();
    } catch (error) {
      lastError = error;
      if (attempt < attempts && shouldRetry(error)) {
        await new Promise<void>((resolve) =>
          window.setTimeout(resolve, delayMs * attempt),
        );
      } else {
        throw error;
      }
    }
  }
  throw lastError;
}

export function isTransientHttpError(error: unknown): boolean {
  const response = (error as { response?: { status?: number } })?.response;
  if (!response) return true;
  const status = response.status || 0;
  return status === 408 || status === 425 || status === 429 || status >= 500;
}
